export const onSWUpdate = () => {
  if ('serviceWorker' in navigator) {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    navigator.serviceWorker.ready.then((registration) => {
      if (registration.waiting) {
        console.log('skip message to kick off the service worker install');
        // send the skip message to kick off the service worker install.
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        // add an listener to reload page when the new service worker is ready.
        registration.waiting.addEventListener('statechange', (event: Event) => {
          console.log('statechange: ', event.target);
          const { state = '' } =
            (event.target as unknown as { state: string }) || {};
          if (state === 'activated') {
            window.location.reload();
          }
        });
      }
    });
  }
};
